import React, { forwardRef, useState } from 'react';
import { Steps } from 'antd';
import { useTitle } from '../../../hooks/useTitle';
import ReferentStep from './ReferentStep';
import IncomeDeclaration from './IncomeDeclaration';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import { availableSteps } from '../../../utils/allSteps';
import { StepKeys } from '../../../shared/enums/steps.enum';
import { ScreeningStep } from '../../../redux/slices/steps.slice';
import { useTranslation } from 'react-i18next';
import { useStep } from '../../../hooks/useStep';

export enum StepToShow {
  OWN = 'ownDeclaration',
  REFERENT = 'ReferentStatement',
}

interface SaveRef {
  save: () => void;
}

const IncomeCheckStep = forwardRef((_, ref: React.ForwardedRef<SaveRef>) => {
  const { t } = useTranslation(['screening/income', 'screening/general']);
  useTitle(t('Title'));
  const [stepToShow, setStepToShow] = useState(StepToShow.OWN);
  const { goToNextStep } = useStep();
  const requiredSteps = useSelector(
    (state: RootState) => state.steps.availableSteps,
  );
  const requiresLandlordStep = requiredSteps.includes(
    availableSteps.find(
      (step) => step.key === StepKeys.landlordStatement,
    ) as ScreeningStep,
  );

  const onNext = () => {
    if (requiresLandlordStep) {
      setStepToShow(StepToShow.REFERENT);
    } else {
      goToNextStep();
    }
  };

  const steps = [
    {
      title: t('TitleIncomeDeclaration'),
      content: <IncomeDeclaration ref={ref} onNext={onNext} />,
      enum: StepToShow.OWN,
    },
    {
      title: t('TitleReferentStatement'),
      content: <ReferentStep />,
      enum: StepToShow.REFERENT,
    },
  ];

  return (
    <div style={{ maxWidth: 500 }}>
      {requiresLandlordStep ? (
        <Steps
          progressDot
          current={steps.findIndex((step) => step.enum === stepToShow)}
          items={steps}
          onChange={(current) => setStepToShow(steps[current].enum)}
        />
      ) : (
        <></>
      )}
      <div style={{ marginTop: 20, display: 'flex', justifyContent: 'center' }}>
        {steps.find((step) => step.enum === stepToShow)?.content}
      </div>
    </div>
  );
});

export default IncomeCheckStep;
